// Valeurs communes pour les ressources cloud (Azure, AWS, GCP)
// Auto-généré le 2025-11-04T23:55:36.509Z
//
// Pour mettre à jour ces valeurs, exécutez:
// npm run update-cloud-values
//
// Sources:
// - Azure: https://azure.microsoft.com/en-us/explore/global-infrastructure/
// - AWS: https://aws.amazon.com/about-aws/global-infrastructure/
// - GCP: https://cloud.google.com/about/locations
//
// Dernières mises à jour:
// - Azure: 2025-11-04T23:55:36.224Z
// - AWS: 2025-11-04T23:55:36.321Z
// - GCP: 2025-11-04T23:55:36.409Z

export interface CloudCommonValues {
  regions: string[];
  vmSizes?: string[];
  instanceTypes?: string[];
  machineTypes?: string[];
  storageTiers?: string[];
  databaseTiers?: string[];
  databaseVersions?: string[];
}

// Azure - Régions et valeurs communes
export const azureCommonValues: CloudCommonValues = {
  regions: [
  "eastus",
  "eastus2",
  "centralus",
  "northcentralus",
  "southcentralus",
  "westcentralus",
  "westus",
  "westus2",
  "westus3",
  "canadacentral",
  "canadaeast",
  "brazilsouth",
  "brazilsoutheast",
  "northeurope",
  "westeurope",
  "francecentral",
  "francesouth",
  "germanywestcentral",
  "norwayeast",
  "norwaywest",
  "swedencentral",
  "switzerlandnorth",
  "switzerlandwest",
  "uksouth",
  "ukwest",
  "australiacentral",
  "australiacentral2",
  "australiaeast",
  "australiasoutheast",
  "centralindia",
  "eastasia",
  "japaneast",
  "japanwest",
  "jioindiawest",
  "koreacentral",
  "koreasouth",
  "southeastasia",
  "southindia",
  "westindia",
  "qatarcentral",
  "southafricanorth",
  "southafricawest",
  "uaenorth",
  "uaecentral"
],
  vmSizes: [
  "Standard_B1s",
  "Standard_B1ms",
  "Standard_B2s",
  "Standard_B2ms",
  "Standard_B4ms",
  "Standard_B8ms",
  "Standard_B12ms",
  "Standard_B16ms",
  "Standard_B20ms",
  "Standard_D2s_v3",
  "Standard_D4s_v3",
  "Standard_D8s_v3",
  "Standard_D16s_v3",
  "Standard_D32s_v3",
  "Standard_D48s_v3",
  "Standard_D64s_v3",
  "Standard_D2ds_v4",
  "Standard_D4ds_v4",
  "Standard_D8ds_v4",
  "Standard_D16ds_v4",
  "Standard_D32ds_v4",
  "Standard_D48ds_v4",
  "Standard_D64ds_v4",
  "Standard_D2ds_v5",
  "Standard_D4ds_v5",
  "Standard_D8ds_v5",
  "Standard_D16ds_v5",
  "Standard_D32ds_v5",
  "Standard_D48ds_v5",
  "Standard_D64ds_v5",
  "Standard_D96ds_v5",
  "Standard_E2s_v3",
  "Standard_E4s_v3",
  "Standard_E8s_v3",
  "Standard_E16s_v3",
  "Standard_E32s_v3",
  "Standard_E48s_v3",
  "Standard_E64s_v3",
  "Standard_E2ds_v4",
  "Standard_E4ds_v4",
  "Standard_E8ds_v4",
  "Standard_E16ds_v4",
  "Standard_E32ds_v4",
  "Standard_E48ds_v4",
  "Standard_E64ds_v4",
  "Standard_E2ds_v5",
  "Standard_E4ds_v5",
  "Standard_E8ds_v5",
  "Standard_E16ds_v5",
  "Standard_E32ds_v5",
  "Standard_E48ds_v5",
  "Standard_E64ds_v5",
  "Standard_E96ds_v5",
  "Standard_F2s_v2",
  "Standard_F4s_v2",
  "Standard_F8s_v2",
  "Standard_F16s_v2",
  "Standard_F32s_v2",
  "Standard_F48s_v2",
  "Standard_F64s_v2",
  "Standard_F72s_v2",
  "Standard_L8s_v2",
  "Standard_L16s_v2",
  "Standard_L32s_v2",
  "Standard_L48s_v2",
  "Standard_L64s_v2",
  "Standard_M8ms",
  "Standard_M16ms",
  "Standard_M32ms",
  "Standard_M64ms",
  "Standard_M128ms"
],
  storageTiers: [
  "Standard_LRS",
  "Standard_GRS",
  "Standard_RAGRS",
  "Standard_ZRS",
  "Standard_GZRS",
  "Standard_RAGZRS",
  "Premium_LRS",
  "Premium_ZRS"
],
  databaseTiers: [
  "Basic",
  "Standard",
  "Premium",
  "GeneralPurpose",
  "BusinessCritical",
  "Hyperscale"
],
  databaseVersions: [
  "5.7",
  "8.0",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "2019-latest",
  "2022-latest"
],
};

// AWS - Régions et valeurs communes
export const awsCommonValues: CloudCommonValues = {
  regions: [
  "us-east-1",
  "us-east-2",
  "us-west-1",
  "us-west-2",
  "ca-central-1",
  "ca-west-1",
  "sa-east-1",
  "eu-central-1",
  "eu-central-2",
  "eu-west-1",
  "eu-west-2",
  "eu-west-3",
  "eu-north-1",
  "eu-south-1",
  "eu-south-2",
  "ap-northeast-1",
  "ap-northeast-2",
  "ap-northeast-3",
  "ap-southeast-1",
  "ap-southeast-2",
  "ap-southeast-3",
  "ap-southeast-4",
  "ap-south-1",
  "ap-south-2",
  "ap-east-1",
  "me-south-1",
  "me-central-1",
  "af-south-1",
  "il-central-1"
],
  instanceTypes: [
  "t2.micro",
  "t2.small",
  "t2.medium",
  "t2.large",
  "t2.xlarge",
  "t2.2xlarge",
  "t3.micro",
  "t3.small",
  "t3.medium",
  "t3.large",
  "t3.xlarge",
  "t3.2xlarge",
  "t3a.micro",
  "t3a.small",
  "t3a.medium",
  "t3a.large",
  "t3a.xlarge",
  "t3a.2xlarge",
  "t4g.micro",
  "t4g.small",
  "t4g.medium",
  "t4g.large",
  "m5.large",
  "m5.xlarge",
  "m5.2xlarge",
  "m5.4xlarge",
  "m5.8xlarge",
  "m5.12xlarge",
  "m5.16xlarge",
  "m5.24xlarge",
  "m6i.large",
  "m6i.xlarge",
  "m6i.2xlarge",
  "m6i.4xlarge",
  "m6i.8xlarge",
  "m6i.12xlarge",
  "m6i.16xlarge",
  "m6i.24xlarge",
  "m6i.32xlarge",
  "m7i.large",
  "m7i.xlarge",
  "m7i.2xlarge",
  "m7i.4xlarge",
  "c5.large",
  "c5.xlarge",
  "c5.2xlarge",
  "c5.4xlarge",
  "c5.9xlarge",
  "c5.12xlarge",
  "c5.18xlarge",
  "c5.24xlarge",
  "c6i.large",
  "c6i.xlarge",
  "c6i.2xlarge",
  "c6i.4xlarge",
  "c6i.8xlarge",
  "c6i.12xlarge",
  "c6i.16xlarge",
  "c6i.24xlarge",
  "c6i.32xlarge",
  "c7i.large",
  "c7i.xlarge",
  "r5.large",
  "r5.xlarge",
  "r5.2xlarge",
  "r5.4xlarge",
  "r5.8xlarge",
  "r5.12xlarge",
  "r5.16xlarge",
  "r5.24xlarge",
  "r6i.large",
  "r6i.xlarge",
  "r6i.2xlarge",
  "r6i.4xlarge",
  "r6i.8xlarge",
  "r6i.12xlarge",
  "r6i.16xlarge",
  "r6i.24xlarge",
  "r6i.32xlarge",
  "x2iedn.xlarge",
  "x2iedn.2xlarge",
  "x2iedn.4xlarge"
],
  storageTiers: [
  "STANDARD",
  "REDUCED_REDUNDANCY",
  "STANDARD_IA",
  "ONEZONE_IA",
  "INTELLIGENT_TIERING",
  "GLACIER",
  "GLACIER_IR",
  "DEEP_ARCHIVE"
],
  databaseTiers: [
  "db.t3.micro",
  "db.t3.small",
  "db.t3.medium",
  "db.t3.large",
  "db.t3.xlarge",
  "db.t3.2xlarge",
  "db.t4g.micro",
  "db.t4g.small",
  "db.t4g.medium",
  "db.t4g.large",
  "db.m5.large",
  "db.m5.xlarge",
  "db.m5.2xlarge",
  "db.m5.4xlarge",
  "db.m5.8xlarge",
  "db.m6i.large",
  "db.m6i.xlarge",
  "db.m6i.2xlarge",
  "db.m6i.4xlarge",
  "db.r5.large",
  "db.r5.xlarge",
  "db.r5.2xlarge",
  "db.r5.4xlarge",
  "db.r5.8xlarge",
  "db.r6i.large",
  "db.r6i.xlarge",
  "db.r6i.2xlarge"
],
  databaseVersions: [
  "5.7",
  "8.0",
  "11.0",
  "12.0",
  "13.0",
  "14.0",
  "15.0",
  "16.0",
  "10.6",
  "10.11"
],
};

// GCP - Régions et valeurs communes
export const gcpCommonValues: CloudCommonValues = {
  regions: [
  "us-central1",
  "us-east1",
  "us-east4",
  "us-east5",
  "us-south1",
  "us-west1",
  "us-west2",
  "us-west3",
  "us-west4",
  "northamerica-northeast1",
  "northamerica-northeast2",
  "southamerica-east1",
  "southamerica-west1",
  "europe-central2",
  "europe-north1",
  "europe-southwest1",
  "europe-west1",
  "europe-west2",
  "europe-west3",
  "europe-west4",
  "europe-west6",
  "europe-west8",
  "europe-west9",
  "europe-west12",
  "asia-east1",
  "asia-east2",
  "asia-northeast1",
  "asia-northeast2",
  "asia-northeast3",
  "asia-south1",
  "asia-south2",
  "asia-southeast1",
  "asia-southeast2",
  "australia-southeast1",
  "australia-southeast2",
  "me-central1",
  "me-west1"
],
  machineTypes: [
  "e2-micro",
  "e2-small",
  "e2-medium",
  "e2-standard-2",
  "e2-standard-4",
  "e2-standard-8",
  "e2-standard-16",
  "e2-standard-32",
  "e2-highmem-2",
  "e2-highmem-4",
  "e2-highmem-8",
  "e2-highmem-16",
  "n1-standard-1",
  "n1-standard-2",
  "n1-standard-4",
  "n1-standard-8",
  "n1-standard-16",
  "n1-standard-32",
  "n1-standard-64",
  "n1-standard-96",
  "n1-highmem-2",
  "n1-highmem-4",
  "n1-highmem-8",
  "n1-highmem-16",
  "n1-highmem-32",
  "n2-standard-2",
  "n2-standard-4",
  "n2-standard-8",
  "n2-standard-16",
  "n2-standard-32",
  "n2-standard-48",
  "n2-standard-64",
  "n2-standard-80",
  "n2-standard-96",
  "n2-standard-128",
  "n2-highmem-2",
  "n2-highmem-4",
  "n2-highmem-8",
  "n2-highmem-16",
  "n2-highmem-32",
  "n2d-standard-2",
  "n2d-standard-4",
  "n2d-standard-8",
  "n2d-standard-16",
  "n2d-standard-32",
  "n2d-standard-48",
  "n2d-standard-64",
  "n2d-standard-80",
  "n2d-standard-96",
  "n2d-standard-128",
  "n2d-standard-224",
  "n2d-highmem-2",
  "n2d-highmem-4",
  "n2d-highmem-8",
  "c2-standard-4",
  "c2-standard-8",
  "c2-standard-16",
  "c2-standard-30",
  "c2-standard-60",
  "c3-standard-4",
  "c3-standard-8",
  "c3-standard-22",
  "c3-standard-44",
  "c3-standard-88",
  "c3-standard-176",
  "m1-ultramem-40",
  "m1-ultramem-80",
  "m1-ultramem-160",
  "m1-megamem-96",
  "m2-ultramem-208",
  "m2-ultramem-416",
  "m2-megamem-416",
  "m3-megamem-64",
  "m3-megamem-128",
  "m3-ultramem-32",
  "m3-ultramem-64",
  "m3-ultramem-128"
],
  storageTiers: [
  "STANDARD",
  "NEARLINE",
  "COLDLINE",
  "ARCHIVE"
],
  databaseTiers: [
  "db-f1-micro",
  "db-g1-small",
  "db-n1-standard-1",
  "db-n1-standard-2",
  "db-n1-standard-4",
  "db-n1-standard-8",
  "db-n1-standard-16",
  "db-n1-standard-32",
  "db-n1-standard-64",
  "db-n1-standard-96",
  "db-n1-highmem-2",
  "db-n1-highmem-4",
  "db-n1-highmem-8",
  "db-n1-highmem-16",
  "db-n1-highmem-32",
  "db-n1-highmem-64",
  "db-n1-highmem-96"
],
  databaseVersions: [
  "MYSQL_5_7",
  "MYSQL_8_0",
  "MYSQL_8_0_18",
  "MYSQL_8_0_26",
  "MYSQL_8_0_31",
  "POSTGRES_10",
  "POSTGRES_11",
  "POSTGRES_12",
  "POSTGRES_13",
  "POSTGRES_14",
  "POSTGRES_15",
  "POSTGRES_16",
  "SQLSERVER_2017_STANDARD",
  "SQLSERVER_2017_ENTERPRISE",
  "SQLSERVER_2019_STANDARD",
  "SQLSERVER_2019_ENTERPRISE",
  "SQLSERVER_2022_STANDARD",
  "SQLSERVER_2022_ENTERPRISE"
],
};

// Mapping de champs vers les valeurs communes
export interface FieldValueMapping {
  fieldName: string;
  provider: 'azure' | 'aws' | 'gcp';
  valueType: keyof CloudCommonValues;
}

// Configuration des mappings automatiques
export const fieldValueMappings: FieldValueMapping[] = [
  // Azure
  { fieldName: 'location', provider: 'azure', valueType: 'regions' },
  { fieldName: 'size', provider: 'azure', valueType: 'vmSizes' },
  { fieldName: 'vm_size', provider: 'azure', valueType: 'vmSizes' },
  { fieldName: 'account_tier', provider: 'azure', valueType: 'storageTiers' },
  { fieldName: 'account_replication_type', provider: 'azure', valueType: 'storageTiers' },
  { fieldName: 'sku_name', provider: 'azure', valueType: 'databaseTiers' },

  // AWS
  { fieldName: 'region', provider: 'aws', valueType: 'regions' },
  { fieldName: 'instance_type', provider: 'aws', valueType: 'instanceTypes' },
  { fieldName: 'storage_class', provider: 'aws', valueType: 'storageTiers' },
  { fieldName: 'instance_class', provider: 'aws', valueType: 'databaseTiers' },
  { fieldName: 'engine_version', provider: 'aws', valueType: 'databaseVersions' },

  // GCP
  { fieldName: 'region', provider: 'gcp', valueType: 'regions' },
  { fieldName: 'zone', provider: 'gcp', valueType: 'regions' },
  { fieldName: 'machine_type', provider: 'gcp', valueType: 'machineTypes' },
  { fieldName: 'storage_class', provider: 'gcp', valueType: 'storageTiers' },
  { fieldName: 'tier', provider: 'gcp', valueType: 'databaseTiers' },
  { fieldName: 'database_version', provider: 'gcp', valueType: 'databaseVersions' },
];

/**
 * Obtenir les valeurs suggérées pour un champ selon le provider
 */
export function getCommonValuesForField(
  fieldName: string,
  provider: 'azure' | 'aws' | 'gcp'
): string[] | null {
  const mapping = fieldValueMappings.find(
    m => m.fieldName === fieldName && m.provider === provider
  );

  if (!mapping) return null;

  const providerValues =
    provider === 'azure' ? azureCommonValues :
    provider === 'aws' ? awsCommonValues :
    gcpCommonValues;

  return providerValues[mapping.valueType] || null;
}

/**
 * Détecter le provider à partir du nom de la ressource Terraform
 */
export function detectProviderFromResource(resourceType: string): 'azure' | 'aws' | 'gcp' | null {
  if (resourceType.startsWith('azurerm_')) return 'azure';
  if (resourceType.startsWith('aws_')) return 'aws';
  if (resourceType.startsWith('google_')) return 'gcp';
  return null;
}
